
import { DRAWER_TYPES } from "../types";

export const setDrawerCurrentState = (selectDrawerState: any) => {
  return {
    type: DRAWER_TYPES.DRAWER_OPEN_SET_SELECTED,
    payload: {...selectDrawerState}
  }
}

export const clearDrawerClose = () => {
  return {
    type: DRAWER_TYPES.DRAWER_CLOSE_SELECTED
  }
}

export const setDrawerWidthCurrentState = (selectDrawerState: any) => {
  return {
    type: DRAWER_TYPES.DRAWER_WIDTH_SET_SELECTED,
    payload: {...selectDrawerState}
  }
}

export const setAppBarSelectedItem = (selectedItem: any) => {
  return {
    type: DRAWER_TYPES.APP_BAR_ITEM_SET_SELECTED,
    payload: {...selectedItem}
  }
}

export const setSubMenuItemsStore = (selectedItem: any) => {
  return {
    type: DRAWER_TYPES.SUB_MENU_ITEMS_SET_SELECTED,
    payload: {...selectedItem}
  }
}
export const setSubMenuItemsClearStore = () => {
  return {
    type: DRAWER_TYPES.SUB_MENU_ITEMS_CLEAR_SELECTED
  }
}
export const setSubMenuVisibilitySetSelected = (selectedItem: any) => {
  return {
    type: DRAWER_TYPES.SUB_MENU_VISIBILITY_SET_SELECTED,
    payload: {...selectedItem}
  }
}
export const setSubMenuItemsVisibilityClear = () => {
  return {
    type: DRAWER_TYPES.SUB_MENU_VISIBILITY_CLEAR_SELECTED
  }
}
export const setSelectedSubMenuItemStore = (selectedItem: any) => {
  return {
    type: DRAWER_TYPES.SUB_MENU_ITEM_SET_SELECTED,
    payload: {...selectedItem}
  }
}
export const setClearSubMenuItemStore = () => {
  return {
    type: DRAWER_TYPES.SUB_MENU_ITEM_CLEAR_SELECTED
  }
}
